import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const StatusContainer = styled.div`
  display: flex;
  gap: 32px;

  @media (max-width: 1124px) {
    flex-direction: column;
    gap: 0;
  }
`

export const ClassificationContainer = styled.div`
  width: 100%;
  display:flex;
  flex-direction: row;
  gap: 16px;

  @media (max-width: 1124px) {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    align-items: center;
    justify-items: center;
  }
`

export const Title = styled.div`
  display: flex;
  width: 95%;
  align-items: flex-start;
  font-family: Circular-Std-Bold;
  font-weight: 500;
  font-size: 32px;
  color: ${colors.strongBlack};

  @media (max-width: 450px) {
    font-size: 22px;
  }
`
